import { pipe } from 'ramda';
import qs from 'qs';
import { DateVLogsPayload } from 'utils/apiClient/services/datev/types';

const extractQueryParam = (param: string) => (url: string | undefined) => {
  if (!url) {
    return null;
  }
  return qs.parse(url.toString().split('?')[1])[param];
};

const getNext = (data: DateVLogsPayload) => data.next;

export const getNextCursor = (data: DateVLogsPayload) =>
  pipe(getNext, extractQueryParam('cursor'))(data);

const getPrevious = (data: DateVLogsPayload) => data.previous;

export const getPreviousCursor = (data: DateVLogsPayload) =>
  pipe(getPrevious, extractQueryParam('cursor'))(data);
